import { setLoading } from "../../../reducer/auth/auth";
import { referOthers, checkreferCode } from "../../../services/profile";
import { useSelector, useDispatch } from 'react-redux';
import { fetchUser } from "../../../services/auth";
import React, { useEffect, useState } from 'react';
import Button from '../../../components/button';
import { toast } from "react-toastify";
import { useTranslation, Trans } from "react-i18next";
import "./index.css"


export default function ReferOthers() {
  const { t } = useTranslation("mediumMisc");
  const dispatch = useDispatch();
  const { id } = useSelector((state) => state.user.user);
  const [userdata, setUserData] = useState("");
  const [referStarter, setreferStarter] = useState("");
  useEffect(() => {
    callProfile();
  }, []);
  const callProfile = async () => {
    dispatch(setLoading(true));
    let userId = `Starter ${id}`;
    let referNumber = userId
      .replace(/\s+/g, '') // Remove whitespace
      .replace(/\D/g, ''); // Remove non-digits
    if (referNumber.length > 4) {
      referNumber = referNumber.slice(-4); // Keep only the last four digits
    } else {
      referNumber = referNumber.padStart(4, '0'); // Pad with leading zeros if less than four digits
    }
    let referName = `Starter ${referNumber}`;
    if (referName) {
      let formattedValue = referName
        .replace(/\s+/g, '')
        .toLowerCase();

      checkUserReferCode(formattedValue);
    }
  };
  const checkUserReferCode = async (referCode) => {

    let item = {
      userId: id,
      referral_code: referCode
    };
    checkreferCode(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          let codeReferValue = data.data.data.refer_code;
          setreferStarter(codeReferValue)
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  }
  const handleClick = () => {
    dispatch(setLoading(true));
    let item = {
      userId: id,
      referral_code: referStarter
    };
    referOthers(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          toast.success(t("referOthers.emailSent"), { position: "top-center" });
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  }

  return (
    <div className="refer-others-page">
      <div className="refer-others-heading">
        {/* <h1>Refer Others</h1>
        <p>Invite Starter Client Volunteers and track your other referral programs.</p> */}
      </div>

      <div className="refer-others-card">
        <div className="refer-others-card-header">
          <h2><Trans i18nKey="referOthers.starterHeading" ns="mediumMisc" components={{ subtitle: <span className="refer-others-card-subtitle" /> }} /></h2>
        </div>

        <div className="refer-others-row">
          <div className="refer-others-row-label">
            <span className="refer-others-accent-bar"></span>
            <h3 className="mainHeading">{t("referOthers.yourReferralCode")}</h3>
          </div>
          <span className="refer-others-code-chip">{referStarter && referStarter}</span>
        </div>

        <div className="refer-others-row refer-others-row-last">
          <div className="refer-others-row-label">
            <span className="refer-others-accent-bar"></span>
            <h3 className="mainHeading">{t("referOthers.sendReferral")}</h3>
          </div>
          <div className="refer-others-send-wrap">
            <div className="d-flex refer-others-actions">
              <Button

                status={0}
                type="button"
                className={`resend-btn w-unset height-45 min-width-130px mt-2 me-3 refer-others-email-btn`}
                title={t("referOthers.referralEmail")}
                onClick={handleClick}

              />
              <div className="hoverContent">
                <div className="hover-container">
                  <p className="hover-target" tabindex="0"> <Button
                    status={0}
                    type="button"
                    className={`resend-btn w-unset height-45 min-width-130px mt-2 refer-others-learnmore-btn`}
                    title={t("referOthers.learnMore")}
                  /></p>
                  <aside className="hover-popup-r">
                    <h2 className="mainHeading">{t("referOthers.learnMorePopup.title")}</h2>
                    <p className="mainpre">{t("referOthers.learnMorePopup.p1")}</p>
                    <p className="mainpre">{t("referOthers.learnMorePopup.p2")}</p>
                    <p className="mainpre"><Trans i18nKey="referOthers.learnMorePopup.p3" ns="mediumMisc" /></p>

                    <p className="mainpre">{t("referOthers.learnMorePopup.p4")}</p>
                    <p className="mainpre">{t("referOthers.learnMorePopup.p5")}</p>
                    <p className="mainpre">{t("referOthers.learnMorePopup.p6")}</p>
                  </aside>
                </div>
              </div>
            </div>
            {/* <p className="refer-others-send-desc">Sends a pre-drafted email with your unique referral code embedded, ready to forward to your nominees.</p> */}
          </div>
        </div>
      </div>

      <div className="refer-others-card">
        <div className="refer-others-card-header">
          <h2>{t("referOthers.otherPrograms")}</h2>
        </div>

        <div className="refer-others-row">
          <div className="refer-others-row-label">
            <span className="refer-others-accent-bar"></span>
            <h3 className="mainHeading">{t("referOthers.otherClients")}</h3>
          </div>
          <h4 className="mainHeading refer-others-tbd-pill">{t("referOthers.tbd")}</h4>
        </div>

        <div className="refer-others-row">
          <div className="refer-others-row-label">
            <span className="refer-others-accent-bar"></span>
            <h3 className="mainHeading">{t("referOthers.otherMediums")}</h3>
          </div>
          <h4 className="mainHeading refer-others-tbd-pill">{t("referOthers.tbd")}</h4>
        </div>

        <div className="refer-others-row refer-others-row-last">
          <div className="refer-others-row-label">
            <span className="refer-others-accent-bar"></span>
            <h3 className="mainHeading">{t("referOthers.mentorsCoaches")}</h3>
          </div>
          <h4 className="mainHeading refer-others-tbd-pill">{t("referOthers.tbd")}</h4>
        </div>
      </div>
    </div>
  )
}
